import styled, { css } from 'styled-components'
import { mediaQueries } from '../../providers/MediaQueryProvider'

export const Container = styled.div`
  max-width: 100%;
`

export const StateContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-500);
`

export const ListItem = styled.div<{
  $highlighted?: boolean
  $topBorder: boolean
  $bottomBorder: boolean
}>`
  padding: var(--space-400) 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--border-tertiary);

  ${({ $topBorder }) =>
    $topBorder &&
    css`
      &:first-of-type {
        border-top: 1px solid var(--border-tertiary);
      }
    `}

  ${({ $bottomBorder }) =>
    !$bottomBorder &&
    css`
      &:last-of-type {
        border-bottom: none;
      }
    `}

  ${mediaQueries.laptop} {
    padding: var(--space-300) 0;
  }

  ${({ $highlighted }) =>
    $highlighted &&
    css`
      background: linear-gradient(
        270deg,
        rgba(0, 87, 255, 0) 0%,
        rgba(0, 87, 255, 0.08) 30.21%,
        rgba(0, 87, 255, 0.08) 68.75%,
        rgba(0, 87, 255, 0) 100%
      );
    `};
`
